import { render, staticRenderFns } from "./Proveedor.vue?vue&type=template&id=b8137b66&scoped=true"
import script from "./Proveedor.vue?vue&type=script&lang=js"
export * from "./Proveedor.vue?vue&type=script&lang=js"
import style0 from "./Proveedor.vue?vue&type=style&index=0&id=b8137b66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8137b66",
  null
  
)

export default component.exports